import React from 'react'
import { PropertiesSettings } from 'src/types/Main'
import Property from './Property'

interface Props {
  properties: PropertiesSettings[];
  startOpen: boolean;
  resetMode: string;
  filteredProperties: Record<string, string[]>;
  filterOnClick: boolean;
  setFilteredProperties(properties: Record<string, string[]>): void;
  clearProperties(properties: Record<string, string[]>): void;
}

export const PropertiesIndex = (props: Props) => {
  const {
    properties,
    startOpen,
    resetMode,
    filteredProperties,
    filterOnClick,
    setFilteredProperties,
    clearProperties
  } = props

  return (
    <React.Fragment>
      {properties.map((property: PropertiesSettings, key: number) => (
        <Property
          key={key}
          property={property}
          startOpen={startOpen}
          resetMode={resetMode}
          filteredProperties={filteredProperties}
          filterOnClick={filterOnClick}
          setFilteredProperties={setFilteredProperties}
          clearProperties={clearProperties}
        />
      ))}
    </React.Fragment>
  )
}

export default PropertiesIndex
